import { cn } from '@/lib/utils'
import { ReadOnlyInput } from '../ui/readonly-input'

import type { FC } from 'react'

interface GridDataDisplayProps {
	top?: string
	main: string
	bottom?: string
	className?: string
	mode?: 'display' | 'input'
	tooltipText?: string
}

export const GridDataDisplay: FC<GridDataDisplayProps> = ({ 
	top, 
	main, 
	bottom, 
	className,
	mode = 'display',
	tooltipText 
}) => {
	return (
		<div className={cn('flex flex-col gap-0.5', className)}>
			{top && (
				<div>
					<p className="text-sm text-muted-foreground">{top}</p>
				</div>
			)}
			<div>
				{mode === 'input' ? (
					<ReadOnlyInput 
						value={main}
						className="text-xl font-semibold"
						tooltipText={tooltipText}
					/>
				) : (
					<h3 className="text-xl font-semibold">{main}</h3>
				)}
			</div>
			{bottom && (
				<div>
					<p className="text-sm text-muted-foreground">{bottom}</p>
				</div>
			)}
		</div>
	)
}
